import {Fragment, useLayoutEffect, useState} from "react";
import {FreeMode, Controller} from 'swiper';
import {Swiper, SwiperSlide as Slide} from 'swiper/react';
import './index.css';
import {useRef} from "react";
import {getI18n, useTranslation} from "react-i18next";
import PC from "../PC";
import RightIconImg from './right.png';
import Mobile from "../Mobile";

function RightIcon({ arr = [], index, activeIndex }) {
  return (
    arr && arr.length > 0 &&
    <img src={RightIconImg}
         style={{
           verticalAlign: 'middle',
           transition: 'transform 0.15s',
           transform: `rotate(${activeIndex === index ? 90 : 0}deg)`
         }}
         className="w-[12px] inline-block ml-[10px]"/>
  );
}

function SecondTabs({ arr, tabHandle, active, i, sortType, setHasThirdTab }) {
  const [activeIndex, setActiveIndex] = useState(null);
  const lang = getI18n().language;
  
  return (
    arr && arr.length > 0 ?
      <div className={`ml-[20px] ${sortType === 'column' ? 'absolute' : ''}`}
           style={{ top: 55 }}>
        {
          arr.map((child, index) => (
            <Fragment key={index}>
              <a
                onClick={() => {
                  setActiveIndex(index);
                  setHasThirdTab(child.children.length > 0);
                  tabHandle(child.categoryId, i, 'second');
                }}
                className={'cursor-pointer ' +
                `${active === child.categoryId ? 'font-bold ' : ''}` +
                `${sortType === 'column' ? 'px-[15px] inline-block' : 'py-[12px] block'}`}
              >
                {lang === 'en' ? child.categoryEnName : child.categoryName}
                <RightIcon
                  arr={child.children}
                  index={index}
                  activeIndex={activeIndex}/>
              </a>
              {
                child.children &&
                child.children.length &&
                activeIndex > 0 &&
                activeIndex === index ?
                  <div className={`ml-[20px] ${sortType === 'column' ? 'absolute' : ''}`}
                       style={{ top: 25 }}>
                    {
                      child.children.map((item, $index) => (
                        <a key={$index}
                           onClick={() => {
                             tabHandle(item.categoryId, i, 'third');
                           }}
                           className={'cursor-pointer py-[12px] ' +
                           `${active === item.categoryId ? 'font-bold ' : ''}` +
                           `${sortType === 'column' ? 'px-[24px] inline-block' : 'block'}`}
                        >{lang === 'en' ? item.categoryEnName : item.categoryName}</a>
                      ))
                    }
                  </div> : null
              }
            </Fragment>
          ))
        }
      
      </div> : null
  );
}

export default function Tabs(props) {
  const [activeIndex, setActiveIndex] = useState(null);
  const [hasThirdTab, setHasThirdTab] = useState(false); // 用于判断 是否有三级分类
  const { t } = useTranslation();
  const swiperRef = useRef(null);
  let realWidth = 0;
  
  const {
    active,
    perview = 3,
    tabs,
    tabKey = null,
    onChange,
    fixed,
    style,
    tabsStyle,
    tabsActiveColor = '#333',
    sortType = '',
  } = props;
  
  const tabHandle = (active, i, type) => {
    onChange(active, type,i);
    
    if (!realWidth) {
      let swiperSlideEl = document.querySelectorAll('.swiper-slide');
      for (let i = 0; i < swiperSlideEl.length; i++) {
        realWidth += swiperSlideEl[i].offsetWidth;
      }
    }
    if (i === 1) {
      return swiperRef.current.swiper.translateTo(0);
    }
    
    if (i > tabs.length - 1) {
      return swiperRef.current.swiper.translateTo(realWidth);
    }
    
    swiperRef.current.swiper.slideTo(i);
  };
  
  const setActiveIndexHandle = (value, index) => {
    setActiveIndex(index);
    tabHandle(value, index);
    setHasThirdTab(false);
  };
  
  const tabsPaddignBottom = () => {
    if (activeIndex === null || !tabs[activeIndex].children || tabs[activeIndex].children.length <= 0) return 0;
    if (activeIndex && sortType === 'column' && hasThirdTab) return 80;
    if (activeIndex && sortType === 'column') return 40;
  };
  
  return (
    <>
      <PC className="md:mb-[20px] relative items-center mdmax:bg-[#f4f4f6]"
          style={{
            style,
            paddingBottom: tabsPaddignBottom(),
          }}>
        {
          tabs.map((item, i) => {
            let label = tabKey && tabKey.label ? item[tabKey.label] : item.label;
            let value = tabKey && tabKey.value ? item[tabKey.value] : item.value;
            
            return (
              <div key={i}
                   style={{ verticalAlign: 'top' }}
                   className={sortType === 'column' ? 'inline-block' : 'block'}>
                <a onClick={() => setActiveIndexHandle(value, i)}
                   style={{ ...tabsStyle }}
                   className={'relative cursor-pointer border-b inline-block py-[18px] text-center text-[16px] md:px-[26px] ' +
                   `${active === value ? 'font-bold' : ''}`}>
                  <span className="inline-block"
                        style={{ verticalAlign: 'middle' }}>{label}</span>
                  {/*{*/}
                  {/*  active === value &&*/}
                  {/*  <i className="h-[3px] w-[24px] inline-block absolute bottom-0 rounded-full left-[50%]" style={{ transform: 'translateX(-50%)', backgroundColor: tabsActiveColor }}/>*/}
                  {/*}*/}
                  <RightIcon activeIndex={activeIndex}
                             arr={item.children}
                             index={i}/>
                </a>
                {
                  activeIndex !== null && activeIndex === i &&
                  <SecondTabs i={i}
                              sortType={sortType}
                              arr={item.children}
                              tabHandle={tabHandle}
                              setHasThirdTab={setHasThirdTab}
                              active={active}/>
                }
              </div>
            );
          })
        }
      </PC>
      <Mobile className={`container ${fixed ? 'fixed' : ''} z-10`}>
        <Swiper
          ref={swiperRef}
          id="tabsSwiper"
          modules={[FreeMode]}
          className="bg-[#f6f6f6] md:hidden"
          slidesPerView={tabs.length > 4 ? 'auto' : tabs.length}>
          {
            tabs.map((item, i) => {
              let label = tabKey && tabKey.label ? item[tabKey.label] : item.label;
              let value = tabKey && tabKey.value ? item[tabKey.value] : item.value;
              return (
                <Slide style={{ padding: '0 17px', width: 'auto' }} key={i}>
                  <div onClick={() => tabHandle(value, i)}
                       className={'text-center py-[12px] text-[14px]' +
                       'container text-[14px] __tabs ' +
                       `${active === value ? 'active' : ''}`}>
                    {t(label)}
                  </div>
                </Slide>
              );
            })
          }
        </Swiper>
      </Mobile>
    </>
  );
}
